import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  setForm,
  saveForm,
} from 'cityads-v3/actions/welcomeform';

import EmptyResults from 'cityads-v3/components/EmptyResults';
import WaitingButton from 'cityads-v3/components/Buttons/WaitingButton';

import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined'
import Typography from '@mui/material/Typography';

import classes from './WelcomeForm.scss';

import {
  WEBMASTER_TYPES,
} from './WelcomeForm';
import { RootState } from 'cityads-v3/types/reducer';

export default function Step1() {
  const { t } = useTranslation(['Welcome'])
  const dispatch = useDispatch()

  const form = useSelector((state: RootState) => state.welcomeform.formData)
  const isSavingForm = useSelector((state: RootState) => state.welcomeform.isSavingForm)

  const handleGoNext = useCallback(() => {
    dispatch(saveForm('personal_settings'))
      .then(() => {
        dispatch(setForm({
          data: {},
          page: 2
        }));
      })
  }, [dispatch])

  const handleTypeChange = useCallback((evt, value) => {
    dispatch(setForm({
      data: {
        webmaster_type: Number(value),
        traffic_type: '',
        traffic_subtypes: [],
        traffic_type_url: '',
      },
      page: 1
    }));
  }, [dispatch])

  return (
    <div>
      <div className={classes.stepContent}>
        <EmptyResults
          className={classes.emptyResultsContainer}
          icon={<CheckCircleOutlinedIcon />}
          emptyText={(
            <div className={classes.welcomeGreetings}>
              {t('description')}
            </div>
          )}
        />
      </div>
      <div className={classes.form}>
        <div className={classes.form__title}>
          {t('step1_title')}
        </div>

        <div className={classes.form__radiogroup}>
          <RadioGroup
            name="personal"
            onChange={handleTypeChange}
            value={String(form.webmaster_type)}
          >
            {WEBMASTER_TYPES(t).map(item => (
              <FormControlLabel
                key={item.value}
                value={String(item.value)}
                control={<Radio />}
                label={<div>
                  <Typography>{item.label}</Typography>
                  {String(form.webmaster_type) === String(item.value) && (
                    <Typography color="textSecondary" className={classes.radioDescription}>{item.description}</Typography>
                  )}
                </div>}
                classes={{
                  root: classes.FormControlLabelRoot,
                  label: classes.FormControlLabelLabel,
                }}
              />
            ))}
          </RadioGroup>
        </div>

        <div className={classes.buttons}>
          <WaitingButton
            variant="contained"
            color="primary"
            onClick={handleGoNext}
            waiting={isSavingForm}
          >
            {t('continue')}
          </WaitingButton>
        </div>
      </div>
    </div>
  );
}
